var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTickNew = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#021135",
    fillRule: "evenodd",
    stroke: "#021135",
    d: "m12.027 21.87 11.7-20.266c.304-.526.97-.71 1.49-.41l1.433.828c.519.3.693.97.39 1.495L13.89 26.294c-.304.526-.97.71-1.49.41l-.056-.033-10.43-6.022a1.156 1.156 0 0 1-.418-1.577l.843-1.46a1.15 1.15 0 0 1 1.574-.427z"
  })));
};
export default SvgTickNew;